import { userControllerFindSelfUser } from '@/api/user/user'
import { getQueryCache, setQueryCache } from '@/shared/lib/query'

const getUserData = async () => {
  const cacheData = getQueryCache.userInfo()
  if (cacheData) return cacheData

  const userData = await userControllerFindSelfUser()
  setQueryCache.userInfo(userData)

  return userData
}

export const getUserInfo = async () => {
  return await getUserData()
}
